import React, { useEffect } from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import { navigateHook } from "../../../../../hooks/use-navigate.js";

const ReportContent = ({ data, boName, showDescription }) => {
    const navigate = navigateHook();

    const prepareText = (value) => { return value?.replace(/\n/g, ' ') ?? ''; };

    useEffect(() => {
        const values = [];

        data.result.forEach((element) => {
            values.push([
                element.attendance_protocol ?? '',
                element.attendance_nature ?? '',
                prepareText(element.attendance_transcription),

                element.dispatch_numbercheckbook ?? 'Sem talão',
                element.dispatch_nature ?? '',
                prepareText(element.dispatch_initialobservation),

                element.bo_number ?? '',
                element.bo_natures ?? '',
                prepareText(element.bo_history),
            ]);
        });

        ReportUtils.createExportableTable(['Protocolo do atendimento', 'Natureza do atendimento', 'Transcrição do atendimento', 'Talão do despacho', 'Natureza do despacho', 'Observação inicial do despacho', `Número ${boName}`, `Natureza ${boName}`, 'Relatório do agente'], values, 'Desvios de natureza');

    }, [data, boName]);

    if (!data?.result || data.result.length === 0) {
        return (
            <div className="alert alert-info p-2 h6 text-center mt-3">
                Nenhum registro encontrado no período informado.
            </div>
        );
    }

    const result = Array.isArray(data.result) ? data.result : [];
    const hasMobile = result.some(item => item.bo_number || item.bo_natures || item.bo_history);

    let attendanceTotal = 0;
    let dispatchTotal = 0;
    let bosTotal = 0;

    return (
        <>
            <table id="nature-deviation-data" className="table report-table !break-word" sheet-name="Desvio de natureza">
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        <th className={hasMobile ? "w-[33%]" : "w-[50%]"}>Atendimento</th>
                        <th className={hasMobile ? "w-[33%]" : "w-[50%]"}>Despacho</th>
                        { hasMobile && ( <th className="w-[34%]">{boName}</th> ) }
                        <th className="w-[1%] print:hidden"></th>
                    </tr>
                </thead>

                <tbody className="bg-white">
                    { result.map((element, index) => {
                            const urlDispatch = `/despacho/dispatch/form/${element.dispatch_id}`;
                            const urlAttendance = `/despacho/attendance/form/${element.attendance_id}`;

                            let urlBO = '';

                            if (element.bo_number) {
                                urlBO = `/bo/redirect/${element.bo_number.replace('/', '-')}`;
                                bosTotal++;
                            }

                            attendanceTotal += (element.attendance_id ? 1 : 0);
                            dispatchTotal += (element.dispatch_id ? 1 : 0);

                            return (
                                <tr key={index} className="!break-word align-top print:break-inside-avoid">
                                    <td>

                                        { element.attendance_protocol && (
                                            <a onClick={() => navigate(urlAttendance, true)} className="inner-link">
                                                {element.attendance_protocol}
                                            </a>
                                        )}

                                        { element.attendance_nature && (
                                            <>
                                                <br/>
                                                {element.attendance_nature}
                                            </>
                                        )}

                                        { showDescription && element.attendance_transcription && (
                                            <>
                                                <br/>
                                                <span className={'!font-bold'}>Transcrição:</span>{' '}
                                                {element.attendance_transcription}
                                            </>
                                        )}

                                    </td>

                                    <td>

                                        <a onClick={() => navigate(urlDispatch, true)} className="inner-link">
                                            {element.dispatch_numbercheckbook ?? "Sem talão"}
                                        </a>

                                        { element.dispatch_nature && (
                                            <>
                                                <br/>
                                                {element.dispatch_nature}
                                            </>
                                        )}

                                        { showDescription && element.dispatch_initialobservation && (
                                            <>
                                                <br/>
                                                <span className={'!font-bold'}>Observação inicial:</span>{' '}
                                                {element.dispatch_initialobservation}
                                            </>
                                        )}

                                    </td>

                                    {hasMobile && (
                                        <td>

                                            { element.bo_number && (
                                                <a onClick={() => navigate(urlBO, true)} className="inner-link">{element.bo_number}</a>
                                            )}

                                            { element.bo_natures && (
                                                 <>
                                                     <br/>
                                                     {element.bo_natures}
                                                 </>
                                            )}

                                            { showDescription && element.bo_history && (
                                                <>
                                                    <br/>
                                                    <span className={'!font-bold'}>Relatório do agente:</span>{' '}
                                                    {element.bo_history}
                                                </>
                                            )}

                                        </td>
                                    )}

                                    <td className="print:hidden"></td>

                                </tr>
                            );
                        })
                    }

                    <tr>
                        <td className={'!font-bold'}>TOTAL: {attendanceTotal}</td>
                        <td className={'!font-bold'}>{dispatchTotal}</td>

                        {hasMobile && (
                            <td className={'!font-bold'}>{bosTotal}</td>
                        )}

                        <td className="print:hidden"></td>
                    </tr>

                </tbody>
            </table>

            <div id="chart-tables"></div>
        </>
    );
};

export default ReportContent;
